import { of } from 'rxjs';
import { EligibilityFn } from '../lib/eligibility.interfaces';
import { Staff } from '../../staff/staff.model';

export const MonitorStudentEligibility: () => EligibilityFn =
  () => (staff: Staff) =>
    of(
      staff.roleInformation?.isStudent
        ? { eligible: true }
        : { eligible: false, reason: $localize`Is not a student anymore` },
    );

export const MonitorNonStudentEligibility: () => EligibilityFn =
  () => (staff: Staff) =>
    of(
      staff.roleInformation?.isStudent
        ? { eligible: false, reason: $localize`Is still a student` }
        : { eligible: true },
    );
